import { REQUEST_BODY } from './constant';
export const checkTransactionData = (transactionData) => {
    if (transactionData.file && transactionData.toDate && transactionData.fromDate) {
        return true
    } else {
        return false
    }
}

export const getTransactionDataCheckBody = (transactionData) => {
    return {
        corporateId: transactionData.corporateId,
        fromDate: transactionData.fromDate,
        toDate: transactionData.toDate
    }
}
export const getTransactionDataRequest = (transactionData) => {
    return {
        ...REQUEST_BODY,
        corporateId: transactionData.id
    }
}

export const dataStatusCheck = (transactionData) => {
    let flag = true;
    for (let i = 0; i < transactionData.length; i++) {
        if (transactionData[i].status === 'PENDING' || transactionData[i].status === 'PROCESSING') {
            flag = false;
            break;
        }
    }
    return flag;
}